import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  // Configurar axios com token
  useEffect(() => {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      localStorage.setItem('token', token);
    } else {
      delete axios.defaults.headers.common['Authorization'];
      localStorage.removeItem('token');
    }
  }, [token]);

  const buscarUsuarioAtual = async () => {
    const response = await axios.get('/auth/me');
    setUser({
      username: response.data.username,
      full_name: response.data.full_name,
      is_superuser: response.data.is_superuser,
      mustChangePassword: response.data.must_change_password,
    });
  };

    // Verificar se tem token ao carregar
  useEffect(() => {
    const checkAuth = async () => {
      if (token) {
        try {
          await buscarUsuarioAtual();
          setLoading(false);
        } catch (error) {
          if (error.response?.status === 401) {
            // Token expirado ou inválido
            logout();
          } else {
            // Erro de rede ou backend fora do ar - mantém o usuário logado
            setLoading(false);
          }
        }
      } else {
        setLoading(false);
      }
    };
    checkAuth();
  }, [token]);

  const login = async (username, password) => {
    try {
      const formData = new URLSearchParams();
      formData.append('username', username);
      formData.append('password', password);

  const response = await axios.post(
    '/auth/login',
    formData,
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  );

      const { access_token } = response.data;
      setToken(access_token);
      setUser({ username });
      return { success: true };
    } catch (error) {
      console.error('Erro no login:', error);
      return {
        success: false,
        error: error.response?.data?.detail || 'Erro ao fazer login'
      };
    }
  };

  const logout = async () => {
    // Revoga o token no servidor (achado A2) antes de apagar do
    // localStorage — logout real, não só client-side. Timeout curto e
    // catch garantem que uma falha de rede nunca trava o logout: o token
    // é apagado no client de qualquer jeito (finally), só loga o erro.
    try {
      await axios.post('/auth/logout', null, { timeout: 5000 });
    } catch (error) {
      console.error('Erro ao revogar sessão no logout:', error);
    } finally {
      setToken(null);
      setUser(null);
    }
  };

  const value = {
    user,
    token,
    loading,
    login,
    logout,
    refreshUser: buscarUsuarioAtual,
    isAuthenticated: !!token
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de AuthProvider');
  }
  return context;
};
